import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "REPLACE_WITH_FIREBASE_API_KEY",
  authDomain: "tenantdispatch.firebaseapp.com",
  projectId: "tenantdispatch",
  storageBucket: "tenantdispatch.firebasestorage.app",
  messagingSenderId: "449183705728",
  appId: "1:449183705728:web:3359294e82cc1618dd1465",
  measurementId: "G-D6L84N55K4"
};

const app = initializeApp(firebaseConfig);

/** Align with callable CORS: dev server on localhost or 127.0.0.1 (port 3000). */
const isLocalDevHost = () =>
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");

/** Must match emulator bind address in firebase.json (127.0.0.1). */
const EMULATOR_HOST = "127.0.0.1";

const useEmulators =
  process.env.REACT_APP_USE_EMULATOR === "true" && isLocalDevHost();

// Make sure both of these lines have 'export' at the start!
export const auth = getAuth(app);

// Must run before any other Auth API usage (signIn, onAuthStateChanged, etc.).
if (useEmulators) {
  try {
    connectAuthEmulator(auth, `http://${EMULATOR_HOST}:9099`, { disableWarnings: true });
  } catch (err) {
    // Already connected or emulator not running
  }
}

export const db = getFirestore(app);
export const storage = getStorage(app);
// Pin region to match Cloud Functions deployment (callable URLs use us-central1).
export const functions = getFunctions(app, "us-central1");

if (useEmulators) {
  try {
    connectFirestoreEmulator(db, EMULATOR_HOST, 8080);
  } catch (err) {
    // Already connected or error
  }

  try {
    connectStorageEmulator(storage, EMULATOR_HOST, 9199);
  } catch (err) {
    // Already connected or error
  }

  try {
    connectFunctionsEmulator(functions, EMULATOR_HOST, 5001);
  } catch (err) {
    // Already connected or error
  }
}
